<!-- header -->
<ion-header>
    <ion-toolbar>
        <ion-title class="ion-text-capitalize">
            <span>{{ preselectedType ? (preselectedType === 'phoneNumber' ? ('label.verify_phone_number' | translate) : ('label.verify_email' | translate)) : ('label.enable_mfa' | translate) }}</span>
        </ion-title>
        <ion-button slot="end" fill="none" (click)="global.closeModal(false)">
            <ion-icon name="close"></ion-icon>
        </ion-button>
    </ion-toolbar>
</ion-header>

<!-- Single-method flow: only OTP verification (no type selection) -->
<ng-container *ngIf="preselectedType">
    <div class="ion-padding">
        <ng-container [ngTemplateOutlet]="preselectedType === 'phoneNumber' ? verifyPhoneNumber : verifyEmail"></ng-container>
    </div>
    <ion-footer>
        <ion-button
            *ngIf="preselectedType === 'phoneNumber'"
            class="btn__primary"
            (click)="verifyPhoneNumberApi()"
            [disabled]="disablePhoneSubmit"
            >{{ 'label.verify_phone_number' | translate }}</ion-button
        >
        <ion-button
            *ngIf="preselectedType === 'email'"
            class="btn__primary"
            (click)="verifyEmailApi()"
            [disabled]="disableEmailSubmit"
            >{{ 'label.verify_email' | translate }}</ion-button
        >
    </ion-footer>
</ng-container>

<!-- Full flow: select type then verify -->
<mat-stepper *ngIf="showTypeSelection" #stepper class="stepper ion-padding" labelPosition="bottom">
    <ng-template matStepperIcon="edit">
        <mat-icon class="pl-0.5"> &#10004;</mat-icon>
    </ng-template>
    <mat-step [label]="'label.select_mfa_type' | translate">
        <ng-container [ngTemplateOutlet]="selectMfaType"></ng-container>
    </mat-step>
    <mat-step
        [label]="'label.verify_phone_number' | translate"
        *ngIf="mfaType === 'phoneNumber' || mfaType === 'both' || !mfaType">
        <ng-container [ngTemplateOutlet]="verifyPhoneNumber"></ng-container>
    </mat-step>

    <mat-step [label]="'label.verify_email' | translate" *ngIf="mfaType === 'email' || mfaType === 'both' || !mfaType">
        <ng-container [ngTemplateOutlet]="verifyEmail"></ng-container>
    </mat-step>
</mat-stepper>

<ng-template #selectMfaType>
    <form #selectMfaType="ngForm" novalidate>
        <div class="flex justify-center">
            <div class="grid gap-y-1">
                <app-form-field label="label.select_mfa_type_desc" class="col-span-full">
                    <mat-radio-group
                        [(ngModel)]="mfaType"
                        name="MFA Type"
                        required
                        (ngModelChange)="onMfaTypeChange($event)">
                        <mat-radio-button *ngIf="!isPhoneEnabled" value="phoneNumber" class="m-5">{{ 'label.mfa_method_phone' | translate }}</mat-radio-button>
                        <mat-radio-button *ngIf="!isEmailEnabled" value="email" class="m-5">{{ 'label.mfa_method_email' | translate }}</mat-radio-button>
                        <mat-radio-button *ngIf="!isPhoneEnabled && !isEmailEnabled" value="both" class="m-5">{{ 'label.mfa_method_phone' | translate }} & {{ 'label.mfa_method_email' | translate }}</mat-radio-button>
                    </mat-radio-group>
                </app-form-field>
            </div>
        </div>
    </form>
</ng-template>

<ng-template #verifyPhoneNumber>
    <form #verifyPhoneNumber="ngForm" novalidate>
        <div class="flex justify-center">
            <div class="grid gap-y-1">
                <app-form-field label="Please enter the OTP sent to the phone number.">
                    <mat-form-field>
                        <input
                            matInput
                            required
                            type="text"
                            [(ngModel)]="otp"
                            name="otp"
                            maxlength="4"
                            inputmode="numeric"
                            pattern="\d*"
                            appNoWhitespace
                            (input)="onPhoneOtpChange($event)" />
                        <mat-error appFieldErrors></mat-error>
                    </mat-form-field>
                </app-form-field>
            </div>
        </div>
    </form>
</ng-template>

<ng-template #verifyEmail>
    <form #verifyEmail="ngForm" novalidate>
        <div class="flex justify-center">
            <div class="grid gap-y-1">
                <app-form-field label="Please enter the OTP sent to the email.">
                    <mat-form-field>
                        <input
                            matInput
                            required
                            type="text"
                            [(ngModel)]="otp"
                            name="otp"
                            maxlength="4"
                            inputmode="numeric"
                            pattern="\d*"
                            appNoWhitespace
                            (input)="onOtpChange($event)" />
                        <mat-error appFieldErrors></mat-error>
                    </mat-form-field>
                </app-form-field>
            </div>
        </div>
    </form>
</ng-template>
<!-- action buttons container for full flow (stepper) -->
<ion-footer *ngIf="showTypeSelection">
    <ion-button *ngIf="stepper?.selectedIndex===0" class="btn__primary" (click)="stepper.next()" [disabled]="!mfaType"
        >{{ 'label.next' | translate }}</ion-button
    >
    <ion-button
        *ngIf="(stepper?.selectedIndex===1 && mfaType==='phoneNumber') || (stepper?.selectedIndex===1 && mfaType==='both')"
        class="btn__primary"
        (click)="verifyPhoneNumberApi()"
        [disabled]="disablePhoneSubmit"
        >{{ 'label.verify_phone_number' | translate }}</ion-button
    >
    <ion-button
        *ngIf="(stepper?.selectedIndex===2 && mfaType==='both')||  (stepper?.selectedIndex===1 && mfaType==='email')"
        class="btn__primary"
        (click)="verifyEmailApi()"
        [disabled]="disableEmailSubmit"
        >{{ 'label.verify_email' | translate }}</ion-button
    >
</ion-footer>
